<script setup lang="ts">
export interface SpamProtectedFormProps {
  onSubmit?: (event: SubmitEvent) => void;
}

import {onBeforeUnmount, onMounted, ref} from 'vue';

const { onSubmit: onSubmitCallback } = defineProps<SpamProtectedFormProps>();

const state = {
  hasMoved: false,
  hasTouched: false,
  hasFocused: false,
  hasScrolled: false,
};

const spambotScoreField = ref<HTMLInputElement|null>(null);

const form = ref<HTMLFormElement>(null);
defineExpose({ form });

onMounted(() =>{
  setTimeout(() => {
    // Hide the honeypot field
    const honeypotField: HTMLInputElement|null = form.value.querySelector('input[name="contact-info"]');
    honeypotField.required = false;
    honeypotField.autocomplete = 'off';
    honeypotField.ariaHidden = 'true';
    honeypotField.previousElementSibling.textContent = 'Merci de laisser ce champ vide'
    honeypotField.parentElement.classList.add('sr-only');
  }, 50);

  spambotScoreField.value = form.value.querySelector('input[name="message[timestamp]"]');

  document.addEventListener('scroll', onScroll);
});

onBeforeUnmount(() => {
  removeScrollListener();
});

function removeScrollListener() {
  document.removeEventListener('scroll', onScroll);
}

function onMousemove() {
  state.hasMoved = true;
}

function onTouch() {
  state.hasTouched = true;
}

function onFocus() {
  state.hasFocused = true;
}

function onScroll() {
  removeScrollListener();
  state.hasScrolled = true;
}

function onSubmit(event: SubmitEvent) {
  spambotScoreField.value.value = [
    state.hasMoved ? 'M' : 'm',
    state.hasTouched ? 'T' : 't',
    state.hasFocused ? 'F' : 'f',
    state.hasScrolled ? 'S' : 's',
  ].join('');

  onSubmitCallback?.(event);
}
</script>

<template>
  <form @mousemove.once="onMousemove"
        @touch.once="onTouch"
        @focusin.once="onFocus"
        @submit="onSubmit"
        ref="form"
  >
    <slot />
  </form>
</template>

<style scoped lang="scss">

</style>
